export const CONST =Object.freeze({
  ADMIN:1,
  CLIENT:2,
  CONSULTANT:3,
})
